/*
 Маппинг настройки ширины таблицы (AnalyticsV2ElementWidth) в числовой множитель.
 Двухфазный подсчёт ширин колонок теперь целиком живёт в QueryTableLite, здесь
 остаётся только преобразование значения ширины.
*/

/** Маппинг AnalyticsV2ElementWidth → числовой множитель (как в widthOptions). */
const WIDTH_MULTIPLIERS: Record<number, number> = {
  5: 0.25,
  6: 0.5,
  7: 0.75,
  0: 1,
  8: 1.25,
  1: 1.5,
  9: 1.75,
  2: 2,
  3: 2.5,
  4: 3,
};

export function widthMultiplierOf(tableWidth: number | undefined): number {
  if (tableWidth === undefined || tableWidth === null) return 1;
  return WIDTH_MULTIPLIERS[tableWidth] ?? 1;
}
